export const iconFontAwesomeToggleStarHalf = (
	<i className="fa-solid fa-star-half"></i>
);
